import api from "@/api";

export default {
  namespaced: true,
  state: () => ({
    schedules: [],
    loading: false,
    error: null
  }),
  mutations: {
    SET_SCHEDULES(state, schedules) {
      state.schedules = Array.isArray(schedules) ? schedules : [];
    },
    ADD_SCHEDULE(state, schedule) {
      state.schedules.push(schedule);
    },
    UPDATE_SCHEDULE(state, updatedSchedule) {
      const index = state.schedules.findIndex(s => s.id === updatedSchedule.id);
      if (index !== -1) {
        state.schedules.splice(index, 1, updatedSchedule);
      }
    },
    DELETE_SCHEDULE(state, scheduleId) {
      state.schedules = state.schedules.filter(s => s.id !== scheduleId);
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    }
  },
  actions: {
    async fetchGroupSchedules({ commit }, { classId, groupId }) {
      commit('SET_LOADING', true);
      try {
        const response = await api.get(`classes/${classId}/groups/${groupId}/schedules`);
        // Handle both array response and object with data property
        const schedules = response.data.data || response.data || [];
        commit('SET_SCHEDULES', schedules);
        return schedules;
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        commit('SET_SCHEDULES', []); // Set empty array on error
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    async createSchedule({ commit }, { classId, groupId, data }) {
      commit('SET_LOADING', true);
      try {
        const response = await api.post(
          `classes/${classId}/groups/${groupId}/schedules`,
          data
        );
        const schedule = response.data.data || response.data;
        commit('ADD_SCHEDULE', schedule);
        return schedule;
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    async updateSchedule({ commit }, { classId, groupId, id, data }) {
      commit('SET_LOADING', true);
      try {
        // Add the schedule ID to the data for validation
        const updateData = {
          ...data,
          _method: 'PUT',
          schedule_id: id
        };
        
        const response = await api.put(
          `classes/${classId}/groups/${groupId}/schedules/${id}`,
          updateData
        );
        const schedule = response.data.data || response.data;
        commit('UPDATE_SCHEDULE', schedule);
        return schedule;
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async deleteSchedule({ commit }, { classId, groupId, id }) {
      commit('SET_LOADING', true);
      try {
        await api.delete(`classes/${classId}/groups/${groupId}/schedules/${id}`);
        commit('DELETE_SCHEDULE', id);
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    groupSchedules: (state) => (groupId) => {
      return Array.isArray(state.schedules) ? state.schedules.filter(s => s.group_id == groupId) : [];
    },
    isLoading: (state) => state.loading,
    error: (state) => state.error
  }
};